import { productObject, productRefinement } from '@coas/validators/payload';
import type { z } from 'zod';
import { productArticleSchema } from '../const/producArticleSchema';
import { slugBaseSchema } from '../const/slugBaseSchema';

export const productDraftObject = productObject.omit({ slug: true }).extend({
    baseSlug: slugBaseSchema,
    article: productArticleSchema.nullable(),
});

export const productDraftInputSchema = productDraftObject.superRefine(productRefinement);

export type ProductDraftInputSchema = z.infer<typeof productDraftInputSchema>;
